export const LANGUAGES = ["", "/uk", "/es"];
export const ADMIN_PANEL_PREFIX_PATH = "/admin-panel";
export const ADMIN_PANEL_ESTABLISHMENT_PATH = `${ADMIN_PANEL_PREFIX_PATH}/establishments`;
export const ADMIN_PANEL_MENU_PATH = `${ADMIN_PANEL_PREFIX_PATH}/menu`;
export const ADMIN_PANEL_STATISTICS_PATH = `${ADMIN_PANEL_PREFIX_PATH}/statistics`;
export const ADMIN_PANEL_PRICING_PATH = `${ADMIN_PANEL_PREFIX_PATH}/pricing`;
export const ADMIN_PANEL_SUBSCRIPTION_SETTINGS_PATH = `${ADMIN_PANEL_PREFIX_PATH}/subscription-settings`;
export const ADMIN_PANEL_SETTINGS_PATH = `${ADMIN_PANEL_PREFIX_PATH}/settings`;
